import { Component, OnInit } from '@angular/core';
import { mensajeSesionExpiradaService } from 'src/app/services/mensajeSesionExpirada.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { TextosService } from 'src/app/services/textos.service';
import { InventarioService } from 'src/app/services/inventario.service';
import { Becas } from 'src/app/models/Becas';

declare var $: any;

@Component({
  selector: 'app-listadodebecas',
  templateUrl: './listadodebecas.component.html',
  styleUrls: ['./listadodebecas.component.css']
})
export class ListadodebecasComponent implements OnInit {
  // Beneficiarios dinámicos
  beneficiados: any[] = [];
  idbecas: any =[];
  folio_sat: any =[];



becasinfo: Becas ={
categoria: '',
numempleado: 0,
folio_sat: '',
total_factura: 0,
importe: 0,
no_factura: '',
fecha_factura: '',
fecha_pagonomina: '',
isr: 0,
beneficiario: '', 
emisor: '',
observacion: '',
no_oficio: '',
fecha_oficio: '',
idplantel: 0,
periodo: 0,
tipopersonal: '',
beneficiado: '',
quincena_pago: ''
}

resetBeca () {
this.becasinfo = {
categoria: '',
numempleado: 0,
folio_sat: '',
total_factura: 0,
importe: 0,
no_factura: '',
fecha_factura: '',
fecha_pagonomina: '',
isr: 0,
beneficiario: '', 
emisor: '',
observacion: '',
no_oficio: '',
fecha_oficio: '',
idplantel: 0,
periodo: 0,
tipopersonal: '',
beneficiado: '',
quincena_pago:''
}

  this.nombreEmpleadoSeleccionado = '';
}

  // Nombre del empleado principal seleccionado
  nombreEmpleadoSeleccionado: string = '';

  // permisos
  DireccionGeneral = false;
  eliminaAsignatura = true;
  agregarAsignatura = true;
  editarAsignatura = true;

  datos = JSON.parse(localStorage.getItem('datos')!);
  mailusu = this.datos.correop;
  idplantel = this.datos.idplantel;
  idplantel1 = this.datos.idplantel;

  cargo: string;
  plantel: string;
  becas: any = [];
  Nombre: string;
  infoplantel: any = [];
  empleado: any = [];
  periodoss: any = [];

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  ////////////////////////////////////
    archivo: File | null = null;
  xmllista: any = [];
  xmlPreview: any = {};   


  constructor(
    private inventarioService: InventarioService,
    private msj: mensajeSesionExpiradaService,
    private router: Router,
    private textosService: TextosService
  ) {
    this.cargo = this.datos.cargodb;
    this.plantel = this.datos.plantel;
    this.Nombre = this.datos.nom;
  }


  ngOnInit(): void {
     this.dtOptions = {
      pagingType: 'full_numbers',
      order: [[0, 'asc']],
      language: { url: 'https://cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json' }
    };
    this.getBecas();
    this.permisos();
    this.getEmpleado();
    this.getplantelinfo();
    this.getPeriodos();
  }

 actualizarNombreEmpleado() {
  const numEmp = String(this.becasinfo.numempleado);
  
  // Busca al empleado seleccionado
  const empleadoSel = this.empleado.find(e => String(e.numpersonal) === numEmp);

  if (empleadoSel) {
    // Asigna el nombre completo
    this.nombreEmpleadoSeleccionado = `${empleadoSel.nombre} ${empleadoSel.appaterno} ${empleadoSel.apmaterno}`;
    this.becasinfo.beneficiado = this.nombreEmpleadoSeleccionado;

    // Asigna automáticamente el idplantel correspondiente
    this.becasinfo.idplantel = empleadoSel.idplantel;
        this.becasinfo.categoria = empleadoSel.puesto ?? ''; 

  } else {
    this.nombreEmpleadoSeleccionado = '';
  
    this.becasinfo.idplantel = null;
    this.becasinfo.categoria = '';

  }
}

calcularImporte50() {
  if (this.becasinfo.total_factura != null) {
    this.becasinfo.importe = Number(this.becasinfo.total_factura) * 0.5;
  } else {
    this.becasinfo.importe = 0;
  }
}


  getplantelinfo() {
    this.inventarioService.getPlantelCatalogo().subscribe(
      res => { if (res == "TOKEN-EXPIRADO") { this.msj.tokenExpiradoCerrarSesion(); return; } this.infoplantel = res; },
      err => console.error(err)
    );
  }

  getEmpleado() {
    this.inventarioService.getEmpleadoCatalogo().subscribe(
      res => { if (res == "TOKEN-EXPIRADO") { this.msj.tokenExpiradoCerrarSesion(); return; } this.empleado = res; console.log("Empleados:", this.empleado); },
      err => console.error(err)
    );
  }

 getBecas() {
    this.inventarioService.getBecaslista().subscribe(
      res => { if (res == "TOKEN-EXPIRADO") { this.msj.tokenExpiradoCerrarSesion(); return; } this.becas = res; this.dtTrigger.next(); },
      err => console.error(err)
    );
  }

getPeriodos(){
       this.inventarioService.getPeriodoCatalogo().subscribe(
         res => {
   
           if(res=="TOKEN-EXPIRADO"){
             this.msj.tokenExpiradoCerrarSesion();   
             return;
         }
   
           this.periodoss = res;
   
         },
         err =>console.error(err)
       );
     }

  permisos() {
    if (["Auxiliar Direccion Academica","Control Escolar Plantel","Director de Plantel","Planes y Programas DG","Servicios Docentes DG","DG Sin Permisos"].includes(this.cargo)) {
      this.eliminaAsignatura = false;
      this.agregarAsignatura = false;
      this.editarAsignatura = false;
    }
  }


pagarbecas(id: any) {

  Swal.fire({
    title: '¿Se realizó el pago?',
    text: 'Esta acción no se puede deshacer.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#720f3c',
    cancelButtonColor: '#606062',
    confirmButtonText: 'Sí, se pagó',
    cancelButtonText: 'No, registrar pendiente',
    background: '#ffffff',
    allowOutsideClick: false
  }).then((result) => {

    // ------------------------------------
    //  SI SE PAGÓ → FECHA + QUINCENA
    // ------------------------------------
    if (result.isConfirmed) {

      Swal.fire({
        title: 'Fecha y quincena del pago',
        html: `
          <input type="date" id="fechaPago" class="swal2-input" style="width:75%;">

          <select id="quincenaSelect" class="swal2-input" style="width:75%;">
            <option value="">Seleccione quincena</option>
            <option>1A. QNA DE ENERO</option>
            <option>2A. QNA DE ENERO</option>
            <option>1A. QNA DE FEBRERO</option>
            <option>2A. QNA DE FEBRERO</option>
            <option>1A. QNA DE MARZO</option>
            <option>2A. QNA DE MARZO</option>
            <option>1A. QNA DE ABRIL</option>
            <option>2A. QNA DE ABRIL</option>
            <option>1A. QNA DE MAYO</option>
            <option>2A. QNA DE MAYO</option>
            <option>1A. QNA DE JUNIO</option>
            <option>2A. QNA DE JUNIO</option>
            <option>1A. QNA DE JULIO</option>
            <option>2A. QNA DE JULIO</option>
            <option>1A. QNA DE AGOSTO</option>
            <option>2A. QNA DE AGOSTO</option>
            <option>1A. QNA DE SEPTIEMBRE</option>
            <option>2A. QNA DE SEPTIEMBRE</option>
            <option>1A. QNA DE OCTUBRE</option>
            <option>2A. QNA DE OCTUBRE</option>
            <option>1A. QNA DE NOVIEMBRE</option>
            <option>2A. QNA DE NOVIEMBRE</option>
            <option>1A. QNA DE DICIEMBRE</option>
            <option>2A. QNA DE DICIEMBRE</option>
          </select>
        `,
        showCancelButton: true,
        confirmButtonColor: '#720f3c',
        cancelButtonColor: '#606062',
        preConfirm: () => {
          const fecha = (document.getElementById('fechaPago') as HTMLInputElement).value;
          const quincena = (document.getElementById('quincenaSelect') as HTMLSelectElement).value;

          if (!fecha) Swal.showValidationMessage('Debe ingresar la fecha de pago');
          if (!quincena) Swal.showValidationMessage('Debe seleccionar la quincena');

          return { fecha, quincena };
        }
      }).then((res2) => {

        if (res2.isConfirmed) {
          const datos = res2.value;

          this.inventarioService.pagarbecas(id, datos.fecha, datos.quincena, 1)
            .subscribe(() => {

              Swal.fire({
                title: '¡Pago registrado!',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false
              });

              setTimeout(() => location.reload(), 1500);
            });
        }

      });

    }
    // ------------------------------------
    //  NO SE PAGÓ → QUINCENA + PAGADO = 3
    // ------------------------------------
    else {

      Swal.fire({
        title: 'Seleccione la quincena del pago pendiente',
        html: `
          <select id="quincenaPendiente" class="swal2-input" style="width:75%;">
            <option value="">Seleccione quincena</option>
            <option>1A. QNA DE ENERO</option>
            <option>2A. QNA DE ENERO</option>
            <option>1A. QNA DE FEBRERO</option>
            <option>2A. QNA DE FEBRERO</option>
            <option>1A. QNA DE MARZO</option>
            <option>2A. QNA DE MARZO</option>
            <option>1A. QNA DE ABRIL</option>
            <option>2A. QNA DE ABRIL</option>
            <option>1A. QNA DE MAYO</option>
            <option>2A. QNA DE MAYO</option>
            <option>1A. QNA DE JUNIO</option>
            <option>2A. QNA DE JUNIO</option>
            <option>1A. QNA DE JULIO</option>
            <option>2A. QNA DE JULIO</option>
            <option>1A. QNA DE AGOSTO</option>
            <option>2A. QNA DE AGOSTO</option>
            <option>1A. QNA DE SEPTIEMBRE</option>
            <option>2A. QNA DE SEPTIEMBRE</option>
            <option>1A. QNA DE OCTUBRE</option>
            <option>2A. QNA DE OCTUBRE</option>
            <option>1A. QNA DE NOVIEMBRE</option>
            <option>2A. QNA DE NOVIEMBRE</option>
            <option>1A. QNA DE DICIEMBRE</option>
            <option>2A. QNA DE DICIEMBRE</option>
          </select>
        `,
        showCancelButton: true,
        confirmButtonColor: '#720f3c',
        cancelButtonColor: '#606062',
        preConfirm: () => {
          const quincena = (document.getElementById('quincenaPendiente') as HTMLSelectElement).value;

          if (!quincena) Swal.showValidationMessage('Debe seleccionar una quincena');

          return quincena;
        }
      }).then((res3) => {

        if (res3.isConfirmed) {
          const quincena = res3.value;

          this.inventarioService.pagarbecas(id, null, quincena, 3)
            .subscribe(() => {
              Swal.fire({
                title: 'Pago marcado como pendiente',
                icon: 'info',
                timer: 1500,
                showConfirmButton: false
              });

              setTimeout(() => location.reload(), 1500);
            });
        }
      });

    }

  });

}





/////////////////////////////
guardarBecas() {
  const mailusuario = this.mailusu;
  const noFactura = this.becasinfo.no_factura?.trim().toUpperCase();

  // 🔹 VALIDAR que el No. de factura NO esté vacío
  if (!noFactura) {
    Swal.fire({
      title: 'Campo obligatorio',
      html: '<p style="text-align:center; color:#333;">Debe ingresar el número de factura antes de guardar.</p>',
      icon: 'warning',
      confirmButtonColor: '#720f3c'
    });
    return; // 🚫 Detiene todo
  }

  // 🔹 CONSULTAR LISTA DE FACTURAS PARA VALIDAR DUPLICADOS
  this.inventarioService.getBecaslista().subscribe({
    next: (lentesExistentes: any[]) => {
      const facturaDuplicada = lentesExistentes.some(
        l => l.no_factura && l.no_factura.trim().toUpperCase() === noFactura
      );

      if (facturaDuplicada) {
        Swal.fire({
          title: 'Factura duplicada',
          html: '<p style="text-align:center; color:#333;">El número de factura que intenta registrar ya existe en el sistema.</p>',
          icon: 'error',
          confirmButtonColor: '#720f3c'
        });
        return; // 🚫 Detiene aquí también
      }

      // ✅ SOLO SI PASA LAS VALIDACIONES, GUARDAR
      this.inventarioService.createBecas(this.becasinfo, mailusuario).subscribe({
        next: (res) => {
          if (res === "TOKEN-EXPIRADO") {
            this.msj.tokenExpiradoCerrarSesion();
            return;
          }

          Swal.fire({
            title: '¡Registrado correctamente!',
            html: '<p style="text-align:center; color:#333;">Se ha guardado correctamente el apoyo de becas.</p>',
            icon: 'success',
            confirmButtonColor: '#720f3c'
          });

          setTimeout(() => location.reload(), 1500);
        },
        error: (err) => {
          console.error(' Error al guardar beca:', err);
          Swal.fire({
            title: 'Error',
            html: '<p style="text-align:center; color:#333;">El número de factura que intenta registrar ya existe en el sistema.</p>',
            icon: 'error',
            confirmButtonColor: '#720f3c'
          });
        }
      });
    },
    error: (err) => {
      console.error(' Error al obtener lista de becas:', err);
      Swal.fire({
        title: 'Error',
        html: '<p style="text-align:center; color:#333;">No se pudo validar el número de factura.</p>',
        icon: 'error',
        confirmButtonColor: '#720f3c'
      });
    }
  });
}
//////////////////////////////////////////////////////////////////
verbecasss(idbecas: any) {
  this.idbecas = idbecas;

  this.inventarioService.getbecasId(idbecas).subscribe(
    (res: any) => {
      if (res === "TOKEN-EXPIRADO") {
        this.msj.tokenExpiradoCerrarSesion();
        return;
      }

      //  Guardar datos
      this.becasinfo = { ...res };

      console.log("Datos recibidos del servidor:", res);

      //  Convertir valores monetarios que vengan como string $1,200.50 → 1200.50
      if (this.becasinfo.total_factura) {
        this.becasinfo.total_factura = Number(
          String(this.becasinfo.total_factura).replace(/[$,]/g, '')
        );
      }

      if (this.becasinfo.importe) {
        this.becasinfo.importe = Number(
          String(this.becasinfo.importe).replace(/[$,]/g, '')
        );
      }

      //  Convertir fechas al formato correcto yyyy-MM-dd
      if (this.becasinfo.fecha_factura) {
        this.becasinfo.fecha_factura = this.formatDate(this.becasinfo.fecha_factura);
      }

      if (this.becasinfo.fecha_oficio) {
        this.becasinfo.fecha_oficio = this.formatDate(this.becasinfo.fecha_oficio);
      }

      if (this.becasinfo.fecha_pagonomina) {
        this.becasinfo.fecha_pagonomina = this.formatDate(this.becasinfo.fecha_pagonomina);
      }

      // Asignar nombre del empleado y plantel
      this.actualizarNombreEmpleado();

      //  Recalcular importe 50% sólo si existe total_factura
      this.calcularImporte50();

    },
    err => console.error(err)
  );
}

verXMLsss(folio_sat: any) {
  console.log('FOLIO ENVIADO:', folio_sat);

  this.inventarioService.getxmlId(folio_sat).subscribe(
    (res: any) => {

      if (res === "TOKEN-EXPIRADO") {
        this.msj.tokenExpiradoCerrarSesion();
        return;
      }

      console.log("XML recibido:", res);

      this.xmlPreview = res; // 👈 aquí

    },
    err => console.error(err)
  );
}

// Función para formatear fecha a YYYY-MM-DD
formatDate(date: string | Date) {
  const d = new Date(date);
  const month = ('0' + (d.getMonth() + 1)).slice(-2);
  const day = ('0' + d.getDate()).slice(-2);
  const year = d.getFullYear();
  return `${year}-${month}-${day}`;
}

   ////////////////////////////////////////////editar/////////////////////////////////////////////
   getBecassssId(){
     this.inventarioService.getbecasId(this.idbecas)
     .subscribe(
       res=> {
   
         if(res=="TOKEN-EXPIRADO"){
           this.msj.tokenExpiradoCerrarSesion();   
           return;
       }
   
         this.becasinfo = res;
        // const fechainiciop = String (this.lentesinfo.fecha_factura).split('T')[0];
        // this.lentesinfo.fecha_factura = fechainiciop;
        // const fechainiciop1 = String (this.lentesinfo.fecha_receta).split('T')[0];
        // this.lentesinfo.fecha_receta = fechainiciop1;
        // const fechainiciop2 = String (this.lentesinfo.fecha_pago).split('T')[0];
        // this.lentesinfo.fecha_pago = fechainiciop2;
        // const fechainiciop3 = String (this.lentesinfo.fecha_oficio).split('T')[0];
        // this.lentesinfo.fecha_oficio = fechainiciop3;
       },
       err=>console.log(err)
     )
   
   }

eliminarbecas(id: any) {
  Swal.fire({
    title: '<i ></i><br>¿Desea eliminar el registro?',
    html: `
      <p style="text-align:center; color:#333; margin:10px 0;">
        Esta acción no se puede deshacer.
      </p>
    `,
    icon: 'warning',
    iconColor: '#c5ab5b',
    showCancelButton: true,
    confirmButtonColor: '#720f3c', // color vino
    cancelButtonColor: '#606062',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    background: '#ffffff',
    backdrop: 'rgba(0,0,0,0.3)',
    allowOutsideClick: false,
    customClass: {
      popup: 'animated-popup shadow-lg rounded-3'
    },
    showClass: {
      popup: 'animate__animated animate__fadeInDown'
    },
    hideClass: {
      popup: 'animate__animated animate__fadeOutUp'
    }
  }).then((result) => {
    if (result.isConfirmed) {
      // ✅ Elimina el registro si confirma
      this.inventarioService.deletebecas(id).subscribe(
        res => {
          if (res === "TOKEN-EXPIRADO") {
            this.msj.tokenExpiradoCerrarSesion();
            return;
          }

          Swal.fire({
            title: '<i ></i><br>¡Registro eliminado!',
            html: `
              <p style="text-align:center; color:#333; margin:10px 0;">
                El registro se ha eliminado correctamente.
              </p>
            `,
            icon: 'success',
            iconColor: '#4CAF50',
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#720f3c',
            background: '#ffffff',
            backdrop: 'rgba(0,0,0,0.3)',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: {
              popup: 'animated-popup shadow-lg rounded-3'
            },
            showClass: {
              popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp'
            }
          });

          // 🔄 Recargar después de 1.5 segundos
          setTimeout(() => {
            location.reload();
          }, 1500);
        },
        err => console.error(err)
      );

    } else if (result.dismiss === Swal.DismissReason.cancel) {
      // ❌ Si cancela, cerrar el Swal
      Swal.close();

      // (Opcional) Mostrar mensaje de cancelación breve
      Swal.fire({
        title: '<i ></i><br>Acción cancelada',
        html: `
          <p style="text-align:center; color:#333; margin:10px 0;">
            No se realizaron cambios.
          </p>
        `,
        icon: 'info',
        iconColor: '#8f124d',
        showConfirmButton: false,
        timer: 1200,
        background: '#ffffff',
        backdrop: 'rgba(0,0,0,0.2)',
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        }
      });
    }
  });
}


actualizarBecas() {
  // Validar que exista el ID de la beca
  if (!this.idbecas) {
    Swal.fire('Error', 'No se encontró el ID de la beca', 'error');
    return;
  }

  const mailusuario = this.mailusu;
  const id = this.idbecas; // ← usamos el id guardado al abrir el modal

  this.inventarioService.updateBecas(id, this.becasinfo, mailusuario).subscribe({
    next: (res: any) => {
      if(res === "TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion();  
        return; 
      }

      Swal.fire({
        title: '¡Beca actualizada!',
        html: '<p style="text-align:center; color:#333;">Se ha actualizado correctamente el apoyo de becas.</p>',
        icon: 'success',
        confirmButtonColor: '#720f3c'
      });

      setTimeout(() => location.reload(), 1500);
    },
    error: (err) => {
      console.error(' Error al actualizar beca:', err);
      Swal.fire({
        title: 'Error',
        html: '<p style="text-align:center; color:#333;">No se pudo actualizar la beca.</p>',
        icon: 'error',
        confirmButtonColor: '#720f3c'
      });
    }
  });
}

///////////////////////////////////
abrirAgregarXML(id: number) {
  this.idbecas = id;   // 🔑 GUARDAMOS LA BECA SELECCIONADA
  $('#Agrexml').modal('show');
}

  cerrarAgregarXML() {
  $('#Agrexml').modal('hide');

  // 🔄 Refresh después de 1.5 segundos
  setTimeout(() => {
    window.location.reload();
  }, 500);
}


 cerrarPreviewXML() {
  $('#previewXML').modal('hide');

  // 🔄 Refresh después de 1.5 segundos
  setTimeout(() => {
    window.location.reload();
  }, 1000);
}


  onFileSelected(event: any) {
    this.archivo = event.target.files[0];
    if (!this.archivo) return;

    const reader = new FileReader();

    reader.onload = () => {
      const xmlText = reader.result as string;

      // Parsear y extraer datos
      this.parseXML(xmlText);

     
      $('#Agrexml').modal('hide');

      setTimeout(() => {
        $('#previewXML').modal('show');
      }, 200); 
    };

    reader.readAsText(this.archivo);
  }

parseXML(xmlString: string) {

  const parser = new DOMParser();
  const xml = parser.parseFromString(xmlString, "text/xml");

  const comprobante = xml.getElementsByTagName("cfdi:Comprobante")[0];
  const conceptos = xml.getElementsByTagName("cfdi:Concepto");

  // 🔹 SOLO IMPUESTOS GLOBALES
  const impuestosNode = xml.getElementsByTagName("cfdi:Impuestos")[0];

  const traslados = impuestosNode
    ? impuestosNode.getElementsByTagName("cfdi:Traslado")
    : [];

  const retenciones = impuestosNode
    ? impuestosNode.getElementsByTagName("cfdi:Retencion")
    : [];

  let subtotal = 0;
  let descuento = 0;
  let base16 = 0;
  let iva16 = 0;
  let base0 = 0;
  let isr = 0;

  // 🔹 CONCEPTOS
  for (let i = 0; i < conceptos.length; i++) {

    subtotal += parseFloat(
      conceptos[i].getAttribute("Importe") || "0"
    );

    descuento += parseFloat(
      conceptos[i].getAttribute("Descuento") || "0"
    );
  }

  // 🔹 IVA
  for (let i = 0; i < traslados.length; i++) {

    const tasa = traslados[i].getAttribute("TasaOCuota");

    const base = parseFloat(
      traslados[i].getAttribute("Base") || "0"
    );

    const importe = parseFloat(
      traslados[i].getAttribute("Importe") || "0"
    );

    if (tasa === "0.160000") {
      base16 = base;
      iva16 = importe;
    }

    if (tasa === "0.000000") {
      base0 = base;
    }
  }

  // 🔹 ISR
  for (let i = 0; i < retenciones.length; i++) {

    const impuesto = retenciones[i].getAttribute("Impuesto");

    const importe = parseFloat(
      retenciones[i].getAttribute("Importe") || "0"
    );

    if (impuesto === "001") {
      isr += importe;
    }
  }

  const total = parseFloat(
    comprobante.getAttribute("Total") || "0"
  );

  this.xmlPreview = {
    folio: comprobante.getAttribute("Folio") || '',
    subtotal: subtotal.toFixed(2),
    descuento: descuento.toFixed(2),

    base16: base16.toFixed(2),
    iva16: iva16.toFixed(2),
    base0: base0.toFixed(2),
    isr: isr.toFixed(2),

    total: total.toFixed(2),

    rfc_emisor:
      xml.getElementsByTagName("cfdi:Emisor")[0]?.getAttribute("Rfc") || '',

    nombre_emisor:
      xml.getElementsByTagName("cfdi:Emisor")[0]?.getAttribute("Nombre") || '',

    rfc_receptor:
      xml.getElementsByTagName("cfdi:Receptor")[0]?.getAttribute("Rfc") || '',

    nombre_receptor:
      xml.getElementsByTagName("cfdi:Receptor")[0]?.getAttribute("Nombre") || '',

    uuid:
      xml.getElementsByTagName("tfd:TimbreFiscalDigital")[0]?.getAttribute("UUID") || '',

    no_certificado_sat:
      xml.getElementsByTagName("tfd:TimbreFiscalDigital")[0]?.getAttribute("NoCertificadoSAT") || ''
  };

  console.log("XML PREVIEW LENTES:", this.xmlPreview);
}

  extract(xml: string, regex: RegExp) {
    const match = xml.match(regex);
    return match ? match[1] : '';
  }

confirmarXML() {

  if (!this.idbecas) {
    Swal.fire('Error', 'No se encontró la beca seleccionada', 'error');
    return;
  }

  const payload = {
    ...this.xmlPreview,
    idbecas: this.idbecas   // 🔑 SE AGREGA
  };

  this.inventarioService.guardarXMLmanual(payload).subscribe({
    next: () => {
      Swal.fire('XML guardado correctamente', '', 'success');
      this.cerrarPreviewXML();

      // 🔄 Refresh después de 1.5 segundos
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    },
    error: err => {
      Swal.fire(
        'Error',
        err.error?.message || 'Error al guardar el XML',
        'error'
      );
    }
  });
}
copiarFallback(texto: string) {

  console.log('Entrando a copiarFallback');

  const textarea = document.createElement('textarea');
  textarea.value = texto;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';

  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  try {
    const resultado = document.execCommand('copy');
    console.log('Resultado execCommand:', resultado);
    this.mostrarToast();
  } catch (err) {
    console.error('Error en fallback:', err);
    Swal.fire('Error', 'No se pudo copiar el texto', 'error');
  }

  document.body.removeChild(textarea);
}
mostrarToast() {
  Swal.fire({
    toast: true,
    position: 'top-end',
    icon: 'success',
    title: 'Copiado al portapapeles',
    showConfirmButton: false,
    timer: 1400,
    timerProgressBar: true,
    background: '#720f3c',
    color: '#ffffff'
  });
}
///////////////////////////////////
copiarTexto(texto: string) {

  console.log('--- INICIANDO COPIAR ---');
  console.log('Texto recibido:', texto);
  console.log('navigator existe?:', typeof navigator);
  console.log('navigator.clipboard:', navigator.clipboard);
  console.log('window.isSecureContext:', window.isSecureContext);
  console.log('Protocolo actual:', window.location.protocol);

  if (!texto) {
    console.log('No hay texto para copiar');
    return;
  }

  if (navigator.clipboard && navigator.clipboard.writeText) {

    console.log('Usando clipboard moderno');

    navigator.clipboard.writeText(texto)
      .then(() => {
        console.log('Copiado correctamente con clipboard moderno');
        this.mostrarToast();
      })
      .catch(err => {
        console.error('Error con clipboard moderno:', err);
        this.copiarFallback(texto);
      });

  } else {

    console.log('Clipboard moderno NO disponible, usando fallback');
    this.copiarFallback(texto);

  }
}


irASAT() {
  window.open(
    'https://verificacfdi.facturaelectronica.sat.gob.mx/',
    '_blank'
  );
}




}
